import React, { useEffect, useState } from "react";
import {
  QIKTRUCK_APP_STORE,
  QIKTRUCK_CONSUMER_SITE,
  QIKTRUCK_PLAY_STORE,
} from "../../constants/mobileApp";
import "./PlatformExperienceNotice.css";

const MOBILE_MQ = "(max-width: 768px)";
const DISMISS_STORAGE_KEY = "qt-hq-platform-notice-dismissed";

function readDismissed() {
  try {
    return localStorage.getItem(DISMISS_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

/**
 * Desktop/tablet: informational bar, dismissible, scrolls away (not sticky).
 * Mobile: sticky bar - portal is desktop-first; use the consumer app on phone.
 */
function PlatformExperienceNotice() {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined" ? window.matchMedia(MOBILE_MQ).matches : false
  );
  const [desktopDismissed, setDesktopDismissed] = useState(readDismissed);

  useEffect(() => {
    const mq = window.matchMedia(MOBILE_MQ);
    const onChange = (event) => setIsMobile(event.matches);
    if (mq.addEventListener) {
      mq.addEventListener("change", onChange);
      return () => mq.removeEventListener("change", onChange);
    }
    mq.addListener(onChange);
    return () => mq.removeListener(onChange);
  }, []);

  const dismissDesktop = () => {
    setDesktopDismissed(true);
    try {
      localStorage.setItem(DISMISS_STORAGE_KEY, "1");
    } catch {
      /* noop */
    }
  };

  if (!isMobile && desktopDismissed) {
    return null;
  }

  return (
    <div
      className={`qt-platform-notice ${
        isMobile ? "qt-platform-notice--sticky" : "qt-platform-notice--dismissible"
      }`}
      role="status"
      aria-live="polite"
    >
      <div className="qt-platform-notice__inner">
        <i className="mdi mdi-information-outline qt-platform-notice__icon" aria-hidden />
        <div className="qt-platform-notice__copy">
          <p className="qt-platform-notice__line qt-platform-notice__line--desktop">
            <strong>Desktop business portal.</strong> QikTruck Business HQ is
            designed for dashboards on a laptop or desktop - billing,
            integrations, and Partner API.{" "}
            <span className="qt-platform-notice__mobile-only">
              On your phone?{" "}
            </span>
            For the best <strong>mobile</strong> experience, download the QikTruck
            app.
          </p>
          <p className="qt-platform-notice__line qt-platform-notice__line--mobile">
            <strong>Best on desktop.</strong> This business portal is not optimized
            for phones. Use a laptop for dashboards, or download the QikTruck app
            for booking and tracking on mobile.
          </p>
        </div>
        <div className="qt-platform-notice__actions">
          <a
            className="qt-platform-notice__btn"
            href={QIKTRUCK_APP_STORE}
            target="_blank"
            rel="noopener noreferrer"
          >
            iOS app
          </a>
          <a
            className="qt-platform-notice__btn"
            href={QIKTRUCK_PLAY_STORE}
            target="_blank"
            rel="noopener noreferrer"
          >
            Android app
          </a>
          <a
            className="qt-platform-notice__link qt-platform-notice__link--quote"
            href={`${QIKTRUCK_CONSUMER_SITE}/quote`}
          >
            Get a quote
          </a>
        </div>
        {!isMobile ? (
          <button
            type="button"
            className="qt-platform-notice__dismiss"
            onClick={dismissDesktop}
            aria-label="Dismiss desktop portal notice"
          >
            <i className="mdi mdi-close" aria-hidden />
          </button>
        ) : null}
      </div>
    </div>
  );
}

export default PlatformExperienceNotice;
